'use strict';

import * as Redux from 'redux';
import Register from './reducers/register';

export default Redux.createStore(
    Redux.combineReducers({
        register: Register
    })
);